module.exports = __webpack_public_path__ + "img/pic20.87cae8a5.jpg";